module.exports = __webpack_public_path__ + "img/PK_Info_Game1.1ac465ea.png";